import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import DesktopDoctorPopUp from './DesktopDoctorPopUp';
import MobileDoctorPopUp from './MobileDoctorPopUp';
import { actions } from './actions/actions';
import { actions as practiceProfileActions } from '../actions/actions';
import { doctorPropType } from './propTypes';
import { practiceProfilePropType } from '../propTypes';
import { go } from '../../routes';
import { isDesktop } from '../../config';
import styles from './doctorProfilePage.module.css';

class DoctorProfilePage extends Component {
  static propTypes = {
    fetchDoctorProfile: PropTypes.func.isRequired,
    getPracticeProfile: PropTypes.func.isRequired,
    doctor: doctorPropType.isRequired,
    isFetching: PropTypes.bool.isRequired,
    clinic: practiceProfilePropType.isRequired,
  };
  componentDidMount() {
    const { orgId, id } = this.props.match.params;
    this.props.fetchDoctorProfile(id);
    if (orgId.toLowerCase() !== this.props.clinic.UrlName.toLowerCase() && orgId !== this.props.clinic.Id) {
      this.props.getPracticeProfile(this.props.match.params.orgId);
    }
  }
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.match.params.id !== this.props.match.params.id) {
      this.props.fetchDoctorProfile(nextProps.match.params.id);
    }
  }
  close = () => {
    go.practiceProfile(this.props.match.params.orgId);
    this.props.clearDoctorProfile();
  };
  render() {
    return isDesktop() ? (
      <div className={styles.wrapper}>
        <DesktopDoctorPopUp
          doctor={this.props.doctor}
          isFetching={this.props.isFetching}
          close={this.close}
        />
      </div>
    ) : (
      <MobileDoctorPopUp
        doctor={this.props.doctor}
        clinic={this.props.clinic}
        practiceId={this.props.match.params.orgId}
        isFetching={this.props.isFetching}
      />
    );
  }
}

const mapStateToProps = state => ({
  isFetching: state.doctorProfileReducer.isFetching,
  doctor: state.doctorProfileReducer.doctor,
  clinic: state.practiceProfileReducer.profile,
});
const mapDispatchToProps = dispatch => ({
  fetchDoctorProfile: bindActionCreators(actions.fetchDoctorProfile, dispatch),
  clearDoctorProfile: bindActionCreators(actions.clearDoctorProfile, dispatch),
  getPracticeProfile: bindActionCreators(
    practiceProfileActions.getPracticeProfile,
    dispatch,
  ),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(DoctorProfilePage);
